// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1pR84","label":"SetPasswdForm_label__M7Fou"};